import { MutationTree } from 'vuex';
import { CoreState } from '../../models';
import { ScrollMutation } from './mutations/scroll.mutation';
import { SetCoreStylesMutation } from './mutations/set-core-styles.mutation';
import { SetDirtyInputMutation } from './mutations/set-dirty-input.mutation';
import { SetHasTabbedMutation } from './mutations/set-has-tabbed.mutation';
import { SetInputQueryMutation } from './mutations/set-input-query.mutation';
import { SetOpenEmpathizeMutation } from './mutations/set-open-empathize.mutation';
import { SetOpenSortListMutation } from './mutations/set-open-sort-list.mutation';
import { SetOpenMutation } from './mutations/set-open.mutation';
import { SetUserAcceptedQueryMutation } from './mutations/set-user-accepted-query.mutation';
import { StateLoadedFromCache } from './mutations/state-loaded-from-cache';
import { WishlistMutation } from './mutations/wishlist.mutation';

export const CORE_MUTATIONS: MutationTree<CoreState> = {
  ...new ScrollMutation().mutations,
  ...new SetCoreStylesMutation().mutations,
  ...new SetDirtyInputMutation().mutations,
  ...new SetHasTabbedMutation().mutations,
  ...new SetInputQueryMutation().mutations,
  ...new SetOpenEmpathizeMutation().mutations,
  ...new SetOpenMutation().mutations,
  ...new SetOpenSortListMutation().mutations,
  ...new SetUserAcceptedQueryMutation().mutations,
  ...new WishlistMutation().mutations,
  ...new StateLoadedFromCache().mutations
};
